import { useMediaQuery } from '@mui/material'
import { useContext, useEffect, useState } from 'react';
import gaiaTheme from '../../../../root-components/theme';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { UserDetailsContext } from '../../../../context/user-details/user-details';
import { IHeadCell } from '../../../../shared/interfaces/table-display.model';
import { TableDisplay } from '../../../presentation-components/miscellaneous-components/table-display';
import { useNavigate } from 'react-router-dom';
import ReportPeriodService from '../../../../shared/services/report-period/report-period.service';
import { IReportPeriod } from '../../../../shared/services/report-period/report-period.model';
import { LoadingPage } from '../../loading-page';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';

export const ReportingGaiaReportPage = () => {
  const navigate = useNavigate();
  //Services
  const reportPeriodService = new ReportPeriodService()
  //Context
  const userDetailsContext = useContext(UserDetailsContext)
  const userDetails = userDetailsContext.userDetails
  const userNotificationsContext = useContext(UserNotificationsContext)
  //State
  const [selected, setSelected] = useState<string[]>([]);
  const [allReportPeriods, setAllReportPeriods] = useState<IReportPeriod[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(10)
  //Loading State
  const [isLoading, setIsLoading] = useState<boolean>(true)
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  //Variables
  const companyName = (!userDetails?.isPartner && userDetails?.partnerOrganisation) || (userDetails?.isPartner && userDetails?.isLoggedInAsClient) ? userDetails?.partnerOrganisation?.partnerName : 'Gaia';

  useEffect(() => {
    reportPeriodService.getAllReportPeriodsWithReportDetailsPagination(`includeGaia=true`, inputPage, perPage)
      .then(response => {
        setIsLoading(false)
        setAllReportPeriods(response.rows)
        setTotalRecords(response.count);
      })
      .catch(err => console.log(err))
  }, [inputPage, perPage])

  const headCells: IHeadCell[] = [
    { id: 'reportPeriod', numeric: false, label: 'Report Period', sortable: false, isHeading: true },
    { id: 'status', numeric: false, label: 'Status', sortable: false, isSubHeading: true },
  ];


  const rows = allReportPeriods.map(reportPeriod => {
    return {
      id: reportPeriod.id,
      reportPeriod: reportPeriod.friendlyName,
      status: reportPeriod.fileDownloads && reportPeriod.fileDownloads.filter(f => f.type === 'gaia').some(file => file.isFinalVersion) ? 'Completed' : reportPeriod.fileDownloads && reportPeriod.fileDownloads.filter(f => f.type === 'gaia').every(file => !file.isFinalVersion) && reportPeriod.fileDownloads.filter(file => file.type === 'gaia').length > 0 ? 'In Progress' : reportPeriod.fileDownloads && reportPeriod.fileDownloads.filter(file => file.type === 'gaia').length === 0 ? 'Not Started' : null
    }
  });

  const handleSelected = (selectedRowId: string[]) => {
    if (!userDetails?.organisation.subscriptionActive || (userDetails.organisation.subscriptionActive && userDetails.organisation.freeTrialDaysRemaining && userDetails.organisation.freeTrialDaysRemaining > 0)) {
      userNotificationsContext.openDialog({ active: true, hideCancelButton: true, title: 'Access Denied', message: `You must have a subscription to ${companyName} Carbon Accounting to be able to download your ${(!userDetails?.isPartner && userDetails?.partnerOrganisation) || (userDetails?.isPartner && userDetails?.isLoggedInAsClient) ? 'Carbon Summary Report' : 'Gaia Carbon Summary Report'}.`, buttonCopy: 'Ok', })
    }
    else {
      if (selectedRowId[0] !== undefined) {
        navigate(`/reporting/carbon-summary-report/${selectedRowId[0]}`)
      }
    }
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title={(!userDetails?.isPartner && userDetails?.partnerOrganisation) || (userDetails?.isPartner && userDetails?.isLoggedInAsClient) ? 'Carbon Summary Report' : 'Gaia Carbon Summary Report'}
        includeBackButton={true}
        backButtonLink='/reporting'
        backButtonText='Back to reporting'
        hasTabs={false}
      />
      <LoadingPage pageReady={!isLoading}>
        {allReportPeriods &&
          <TableDisplay
            headCells={headCells}
            isMobileMode={isMobileMode}
            rows={rows}
            handleSelected={handleSelected}
            selected={selected}
            setSelected={setSelected}
            inputPage={inputPage}
            setInputPage={setInputPage}
            totalRecords={totalRecords}
            perPage={perPage}
            setPerPage={setPerPage} />
        }
      </LoadingPage>
    </PageOuterContainer>)
}